
import moment from "moment";
import _ from "lodash";
import { mapGetters } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { SistemaMixin } from "@/modules/Application";
import PessoaForm from "@/modules/Pessoa/pages/Form.vue";
import PessoaData from "@/modules/Pessoa/pages/PessoaData";
import ServicosForm from "@/modules/Servicos/pages/ServicosForm.vue";
import ChevronLeft from "vue-material-design-icons/ChevronLeft.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import ClockOutline from "vue-material-design-icons/ClockOutline.vue";

export default {
  name: "app-agendamento-form",
  mixins: [SistemaMixin],
  components: {
    VueSelect,
    PessoaForm,
    ServicosForm,
    ChevronLeft,
    ChevronRight,
    ClockOutline,
  },
  data() {
    return {
      step: 1,
      steps: [
        { id: 1, label: "Dados" },
        { id: 2, label: "Horários" },
        { id: 3, label: "Revisão" },
      ],
      clientes: [],
      tecnicos: [],
      usuarios: [],
      servicos: [],
      novaPessoa: new PessoaData({}),
      novoServicoModalKey: 0,
      loadingHorarios: false,
      searchingNextAvailable: false,
      horariosError: "",
      selectedSlot: null,
      horarios: {
        expediente: null,
        slots: [],
        ocupados: [],
        resumo: null,
      },
      form: {
        cliente: null,
        tecnico: null,
        usuario: null,
        servico: null,
        titulo: "",
        descricao_servico: "",
        data: moment().format("YYYY-MM-DD"),
        duracao_minutos: null,
        observacoes: "",
        status: "agendado",
      },
      agendaConfig: {
        determinar_servico: true,
      },
    };
  },
  computed: {
    ...mapGetters(["currentUser"]),
    isUpdate() {
      return !!this.$route.params.id;
    },
    formattedSelectedDate() {
      return moment(this.form.data).format("dddd, DD/MM/YYYY");
    },
    selectedSlotLabel() {
      if (!this.selectedSlot) return "-";
      return `${moment(this.selectedSlot.inicio).format(
        "DD/MM/YYYY HH:mm"
      )} - ${moment(this.selectedSlot.fim).format("HH:mm")}`;
    },
    expedienteLabel() {
      const expediente = this.horarios.expediente;

      if (!expediente) return "08:00 às 18:00";
      if (expediente.fechado) return "Fechado";

      return `${expediente.inicio || "08:00"} às ${expediente.fim || "18:00"}`;
    },
    totalSlotsCount() {
      return this.horarios.slots.length;
    },
    availableSlotsCount() {
      return this.horarios.slots.filter((slot) => slot.disponivel).length;
    },
    busySlotsCount() {
      return this.horarios.slots.filter((slot) => !slot.disponivel).length;
    },
    hasSlots() {
      return this.totalSlotsCount > 0;
    },
    hasAvailableSlots() {
      return this.availableSlotsCount > 0;
    },
    slotGroups() {
      const groups = [
        { label: "Manhã", start: "00:00", end: "11:59", slots: [] },
        { label: "Tarde", start: "12:00", end: "16:59", slots: [] },
        { label: "Fim do dia", start: "17:00", end: "23:59", slots: [] },
      ];

      this.horarios.slots.forEach((slot) => {
        const hora = slot.hora || moment(slot.inicio).format("HH:mm");
        const group = groups.find(
          (item) => hora >= item.start && hora <= item.end
        );

        if (group) {
          group.slots.push(slot);
        }
      });

      return groups
        .filter((group) => group.slots.length)
        .map((group) => ({
          ...group,
          total: group.slots.length,
          available: group.slots.filter((slot) => slot.disponivel).length,
        }));
    },
    servicoLabel() {
      return (
        this.form.servico?.discriminacao ||
        this.form.descricao_servico ||
        "Duração manual"
      );
    },
    servicoFormLabel() {
      return this.agendaConfig.determinar_servico
        ? "Serviço"
        : "Serviço (opcional)";
    },
    agendaUser() {
      return this.currentUser.admin
        ? this.form.usuario
        : {
            id_usuario: this.currentUser?.id_usuario,
            nome: this.currentUser?.nome || this.currentUser?.usuario,
            usuario: this.currentUser?.usuario,
          };
    },
    responsavelLabel() {
      return this.usuarioLabel(this.agendaUser);
    },
    duracaoBloqueadaPorServico() {
      return this.agendaConfig.determinar_servico;
    },
    duracaoLabel() {
      const duracao =
        this.form.servico?.duracao_minutos || this.form.duracao_minutos;

      return duracao
        ? this.formatDuration(duracao)
        : "Selecione um serviço com duração";
    },
    duracaoValida() {
      const duracao = Number(this.form.duracao_minutos);
      return Number.isInteger(duracao) && duracao >= 1 && duracao <= 1440;
    },
    clienteTelefone() {
      const cliente = this.form.cliente;
      const fone = cliente?.fones?.[0] || cliente?.telefones?.[0];
      return (
        fone?.fone ||
        fone?.telefone ||
        fone?.numero ||
        cliente?.telefone ||
        cliente?.celular ||
        null
      );
    },
    clienteEmail() {
      const cliente = this.form.cliente;
      const email = cliente?.emails?.[0];
      return email?.email || cliente?.email || null;
    },
  },
  methods: {
    goToStep(next) {
      if (next === 1 || this.canLeaveStep(next - 1)) {
        this.step = next;
        if (next === 2) this.loadHorarios();
      }
    },
    nextStep() {
      if (!this.canLeaveStep(this.step)) return;
      this.step += 1;
      if (this.step === 2) this.loadHorarios();
    },
    canLeaveStep(step) {
      if (step === 1) {
        if (!this.form.cliente?.id_pessoa) {
          this.$toast.warning("Selecione o cliente.");
          return false;
        }

        if (!this.agendaUser?.id_usuario) {
          this.$toast.warning("Selecione o responsável da agenda.");
          return false;
        }

        if (
          this.agendaConfig.determinar_servico &&
          !this.form.servico?.id_servico
        ) {
          this.$toast.warning("Selecione o serviço.");
          return false;
        }

        if (!this.duracaoValida) {
          this.$toast.warning(
            "Informe uma duração válida entre 1 e 1440 minutos."
          );
          return false;
        }
      }

      if (step === 2 && !this.selectedSlot) {
        this.$toast.warning("Selecione um horário disponível.");
        return false;
      }

      return true;
    },
    setCliente(cliente) {
      this.form.cliente = cliente;
    },
    async setUsuario(usuario) {
      this.form.usuario = usuario;
      this.clearSelectedSlot();
      await this.loadAgendaConfig();
      this.loadHorarios();
    },
    setTecnico(tecnico) {
      this.form.tecnico = tecnico;
      this.clearSelectedSlot();
      this.loadHorarios();
    },
    setServico(servico) {
      if (!servico) {
        const limparDuracao = this.duracaoBloqueadaPorServico;
        this.form.servico = null;
        this.form.descricao_servico = "";
        if (limparDuracao) {
          this.form.duracao_minutos = null;
        }
        this.clearSelectedSlot();
        this.loadHorarios();
        return;
      }

      this.form.servico = servico;
      this.form.descricao_servico = servico.discriminacao;
      this.form.duracao_minutos = servico.duracao_minutos
        ? Number(servico.duracao_minutos)
        : this.form.duracao_minutos;
      this.clearSelectedSlot();
      this.loadHorarios();
    },
    selectSlot(slot) {
      if (!slot.disponivel) return;
      this.selectedSlot = slot;
    },
    clearSelectedSlot() {
      this.selectedSlot = null;
    },
    changeDate() {
      this.clearSelectedSlot();
      this.loadHorarios();
    },
    changeDuration() {
      this.clearSelectedSlot();
      this.loadHorarios();
    },
    moveDate(days) {
      this.form.data = moment(this.form.data)
        .add(days, "days")
        .format("YYYY-MM-DD");
      this.clearSelectedSlot();
      this.loadHorarios();
    },
    setToday() {
      this.form.data = moment().format("YYYY-MM-DD");
      this.clearSelectedSlot();
      this.loadHorarios();
    },
    normalizeDate(value) {
      const date = moment(value, ["YYYY-MM-DD", "DD/MM/YYYY"], true);

      return date.isValid()
        ? date.format("YYYY-MM-DD")
        : moment(value).format("YYYY-MM-DD");
    },
    applyHorariosResponse(data) {
      this.horarios = {
        expediente: data.expediente || null,
        slots: data.slots || [],
        ocupados: data.ocupados || [],
        resumo: data.resumo || null,
      };
    },
    async fetchHorarios(data) {
      const response = await this.$http.post("/agendamentos/horarios", {
        data,
        id_usuario: this.agendaUser?.id_usuario,
        id_tecnico: this.form.tecnico?.id_tecnico || null,
        id_servico: this.form.servico?.id_servico || null,
        duracao_minutos: Number(this.form.duracao_minutos),
        id_agendamento: this.$route.params.id || null,
      });

      return response.data;
    },
    async loadHorarios() {
      if (!this.form.data || !this.duracaoValida) {
        this.horariosError = "";
        this.applyHorariosResponse({
          expediente: null,
          slots: [],
          ocupados: [],
        });
        return;
      }

      this.loadingHorarios = true;
      this.horariosError = "";
      try {
        const data = this.normalizeDate(this.form.data);
        this.form.data = data;
        this.applyHorariosResponse(await this.fetchHorarios(data));
      } catch (error) {
        this.applyHorariosResponse({
          expediente: null,
          slots: [],
          ocupados: [],
        });
        this.horariosError =
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Não foi possível carregar os horários disponíveis.";
      } finally {
        this.loadingHorarios = false;
      }
    },
    async goToNextAvailableDate() {
      if (!this.duracaoValida) {
        this.$toast.warning("Informe uma duração válida.");
        return;
      }

      this.searchingNextAvailable = true;
      this.loadingHorarios = true;
      this.horariosError = "";

      try {
        const start = moment(this.form.data);

        for (let day = 1; day <= 30; day += 1) {
          const data = start.clone().add(day, "days").format("YYYY-MM-DD");
          const horarios = await this.fetchHorarios(data);
          const hasAvailable = (horarios.slots || []).some(
            (slot) => slot.disponivel
          );

          if (hasAvailable) {
            this.form.data = data;
            this.clearSelectedSlot();
            this.applyHorariosResponse(horarios);
            return;
          }
        }

        this.horariosError =
          "Não encontrei horários livres nos próximos 30 dias.";
      } catch (error) {
        this.horariosError =
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Não foi possível buscar o próximo horário disponível.";
      } finally {
        this.loadingHorarios = false;
        this.searchingNextAvailable = false;
      }
    },
    slotLabel(slot) {
      const inicio = slot.hora || moment(slot.inicio).format("HH:mm");
      const fim = slot.fim ? moment(slot.fim).format("HH:mm") : "";

      return fim ? `${inicio} - ${fim}` : inicio;
    },
    slotStatusLabel(slot) {
      return slot.disponivel ? "Livre" : slot.motivo || "Ocupado";
    },
    async save() {
      if (!this.canLeaveStep(2)) return;

      this.addLoadingToButton("submit_agendamento");
      try {
        const payload = {
          id_pessoa: this.form.cliente.id_pessoa,
          id_usuario: this.agendaUser?.id_usuario,
          id_tecnico: this.form.tecnico?.id_tecnico || null,
          id_servico: this.form.servico?.id_servico || null,
          titulo: this.form.titulo || this.servicoLabel,
          descricao_servico:
            this.form.servico?.discriminacao ||
            this.form.descricao_servico ||
            this.form.titulo ||
            "Agendamento",
          data_inicio: this.selectedSlot.inicio,
          duracao_minutos: Number(this.form.duracao_minutos),
          status: this.form.status || "agendado",
          observacoes: this.form.observacoes,
        };

        if (this.isUpdate) {
          payload.id_agendamento = this.$route.params.id;
        }

        const endpoint = this.isUpdate
          ? this.$route.query.reagendar
            ? "/agendamentos/reagendar"
            : "/agendamentos/update"
          : "/agendamentos/create";

        if (this.$route.query.reagendar) {
          payload.motivo_reagendamento = this.$route.query.motivo;
        }

        await this.$http.post(endpoint, payload);

        this.$toast.success("Agendamento salvo com sucesso!");
        this.$router.push({ name: "agendamentos" });
      } finally {
        this.removeLoadingToButton("submit_agendamento");
      }
    },
    cancel() {
      this.$router.push({ name: "agendamentos" });
    },
    formatTime(value) {
      return value ? moment(value).format("HH:mm") : "--:--";
    },
    formatDuration(value) {
      const minutes = Number(value);
      if (!minutes) return "-";
      if (minutes < 60) return `${minutes} min`;

      const hours = Math.floor(minutes / 60);
      const rest = minutes % 60;
      return rest ? `${hours}h${String(rest).padStart(2, "0")}` : `${hours}h`;
    },
    usuarioLabel(usuario) {
      return usuario?.nome || usuario?.usuario || "-";
    },
    servicoOptionLabel(servico) {
      if (!servico) return "";
      const duracao = servico.duracao_minutos
        ? this.formatDuration(servico.duracao_minutos)
        : "sem duração";
      return `${servico.discriminacao} (${duracao})`;
    },
    servicoSelectable(servico) {
      if (!servico) return false;
      if (!this.agendaConfig.determinar_servico) return true;

      return !!servico.duracao_minutos;
    },
    openNovoClienteModal() {
      this.novaPessoa = new PessoaData({});
      this.$bvModal.show("novoClienteAgendamentoModal");
    },
    resetNovoClienteModal() {
      this.novaPessoa = new PessoaData({});
    },
    async handleNovoClienteSaved({ response, form }) {
      try {
        const cliente = await this.resolveClienteCriado(response, form);

        if (!cliente?.id_pessoa) {
          this.$toast.warning(
            "Cliente cadastrado, mas não foi possível selecioná-lo automaticamente."
          );
          this.$bvModal.hide("novoClienteAgendamentoModal");
          return;
        }

        this.clientes = [cliente];
        this.setCliente(cliente);
        this.$bvModal.hide("novoClienteAgendamentoModal");
        this.$toast.success("Cliente cadastrado e selecionado!");
      } catch (error) {
        this.$toast.error(
          "Cliente cadastrado, mas houve erro ao selecionar no agendamento."
        );
      }
    },
    async resolveClienteCriado(response, form) {
      const responseData = response?.data ?? response;
      const id_pessoa = responseData?.id_pessoa ?? responseData?.id;
      const cliente =
        responseData?.pessoa ??
        responseData?.cliente ??
        responseData?.data ??
        responseData;

      if (cliente?.id_pessoa) return cliente;

      if (id_pessoa) {
        const { data } = await this.$http.post("/pessoa/find", { id_pessoa });
        return data?.pessoa ?? data?.data ?? data;
      }

      const clientes = await this.getClientes(form?.nome ?? "");
      return clientes.find((item) => item.nome === form?.nome) ?? clientes[0];
    },
    openNovoServicoModal() {
      this.novoServicoModalKey += 1;
      this.$bvModal.show("novoServicoAgendamentoModal");
    },
    resetNovoServicoModal() {
      this.novoServicoModalKey += 1;
    },
    async handleNovoServicoSaved({ response, form }) {
      try {
        const servico = await this.resolveServicoCriado(response, form);

        if (!servico?.id_servico) {
          this.$toast.warning(
            "Serviço cadastrado, mas não foi possível selecioná-lo automaticamente."
          );
          this.$bvModal.hide("novoServicoAgendamentoModal");
          return;
        }

        this.servicos = [servico];
        this.setServico(servico);
        this.$bvModal.hide("novoServicoAgendamentoModal");
        this.$toast.success("Serviço cadastrado e selecionado!");
      } catch (error) {
        this.$toast.error(
          "Serviço cadastrado, mas houve erro ao selecionar no agendamento."
        );
      }
    },
    async resolveServicoCriado(response, form) {
      const responseData = response?.data ?? response;
      const id_servico = responseData?.id_servico ?? responseData?.id;
      const servico =
        responseData?.servico ?? responseData?.data ?? responseData;

      if (servico?.id_servico) return servico;

      if (id_servico) {
        const { data } = await this.$http.post("/servicos/find", {
          id_servico,
        });
        return data?.servico ?? data?.data ?? data;
      }

      const { data } = await this.$http.post("/servicos/filter", {
        discriminacao: form?.discriminacao ?? "",
      });
      return (
        data.find((item) => item.discriminacao === form?.discriminacao) ??
        data[0]
      );
    },
    onSearchCliente(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCliente(loading, search, this);
      }
    },
    searchCliente: _.debounce(async (loading, search, vm) => {
      vm.clientes = await vm.getClientes(search);
      loading(false);
    }, 350),
    onSearchTecnico(search, loading) {
      const busca = this.prepararBuscaDireta(search, loading);
      busca.loading(true);
      this.searchTecnico(busca.loading, busca.termo, this);
    },
    searchTecnico: _.debounce(async (loading, search, vm) => {
      const { data } = await vm.$http.post("/tecnico/get-tecnico", { search });
      vm.tecnicos = data;
      loading(false);
    }, 350),
    onSearchUsuario(search, loading) {
      if (search.length) {
        loading(true);
        this.searchUsuario(loading, search, this);
      }
    },
    searchUsuario: _.debounce(async (loading, search, vm) => {
      await vm.loadUsuarios(search);
      loading(false);
    }, 350),
    async loadUsuarios(search = "") {
      if (!this.currentUser.admin) {
        this.form.usuario = this.agendaUser;
        return;
      }

      const { data } = await this.$http.post("/usuario/get-usuarios", {
        search,
      });
      this.usuarios = Array.isArray(data) ? data : data.data || [];

      const queryUserId = Number(this.$route.query.id_usuario);
      const currentUserId = this.currentUser?.id_usuario;
      const selectedId =
        this.form.usuario?.id_usuario || queryUserId || currentUserId;
      const selected = this.usuarios.find((usuario) => {
        return Number(usuario.id_usuario) === Number(selectedId);
      });

      if (!this.form.usuario) {
        this.form.usuario = selected || this.usuarios[0] || null;
      }
    },
    onSearchServico(search, loading) {
      if (search.length) {
        loading(true);
        this.searchServico(loading, search, this);
      }
    },
    searchServico: _.debounce(async (loading, search, vm) => {
      const { data } = await vm.$http.post("/servicos/filter", {
        discriminacao: search,
      });
      vm.servicos = data;
      loading(false);
    }, 350),
    async loadAgendamento() {
      const { data } = await this.$http.post("/agendamentos/find", {
        id_agendamento: this.$route.params.id,
      });

      this.form = {
        cliente: data.pessoa,
        tecnico: data.tecnico,
        usuario: data.usuario,
        servico: data.servico,
        titulo: data.titulo || "",
        descricao_servico: data.descricao_servico || "",
        data: moment(data.data_inicio).format("YYYY-MM-DD"),
        duracao_minutos: data.duracao_minutos,
        observacoes: data.observacoes || "",
        status: data.status || "agendado",
      };

      this.clientes = data.pessoa ? [data.pessoa] : [];
      this.tecnicos = data.tecnico ? [data.tecnico] : [];
      this.usuarios = data.usuario
        ? [data.usuario, ...this.usuarios]
        : this.usuarios;
      this.servicos = data.servico ? [data.servico] : [];
      this.selectedSlot = {
        inicio: moment(data.data_inicio).format("YYYY-MM-DD HH:mm:ss"),
        fim: moment(data.data_fim).format("YYYY-MM-DD HH:mm:ss"),
        hora: moment(data.data_inicio).format("HH:mm"),
        disponivel: true,
      };
      await this.loadHorarios();
    },
    async loadAgendaConfig() {
      const { data } = await this.$http.post("/agendamentos/configuracao", {
        id_usuario: this.currentUser?.id_usuario,
      });
      const config = data.data || data;

      this.agendaConfig = {
        determinar_servico: config.determinar_servico !== false,
      };

      if (!this.agendaConfig.determinar_servico && !this.form.duracao_minutos) {
        this.form.duracao_minutos = 15;
      }
    },
  },
  async created() {
    moment.locale("pt-br");
    await this.loadUsuarios();
    await this.loadAgendaConfig();
    if (this.isUpdate) {
      await this.loadAgendamento();
    }
  },
};
